import { render, staticRenderFns } from "./ChatMessageDocumentComponent.vue?vue&type=template&id=7afdcc42&"
import script from "./ChatMessageDocumentComponent.vue?vue&type=script&lang=ts&"
export * from "./ChatMessageDocumentComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports